import './CreateWorkstation.scss';
import React from 'react';
import { useState, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { Workstation } from '../../../../../types';
import { toast } from 'react-toastify';
import { createWorkstation } from '../../../../../../../../crud/management_api/workstations';
import { TerminalOption, getTerminalOptions } from './../utils/utils';
import SearchDropdown from '../../../../../../../../components/common/SearchDropdown/SearchDropdown';
import { HiOutlineInformationCircle } from 'react-icons/hi2';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';


const CreateWorkstation: React.FC<any> = ({
    showCreateModal,
    setShowCreateModal,
    setCurrentData,
    currentData,
    onWorkstationCreated
  }) => {
    const [terminals, setTerminals] = useState<TerminalOption[]>([]);
    const [isCaja, setIsCaja] = useState(false);
    const [terminalId, setTerminalId] = useState<number | null>(null)

    useEffect(() => {
      getTerminalOptions().then((response) => {
            if (response) {
            setTerminals(response);
            }
        });
        }, []);

    const handleCajaChange = (e: any) => {
      setIsCaja(e.target.checked);
    };

    const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      const form = e.currentTarget;
      if (!form) {
        console.error('Form not found.');
        return;
      }
    const userContext = localStorage.getItem('user');
    const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
    const user_id = userContext != null ? JSON.parse(userContext).user_id : 0;
    const create_workstation: Workstation = {
        workstation_id: '',
        workstation_name: form.workstation_name.value,
        workstation_description: form.workstation_description.value,
        terminal_name: '',
        local_id: localId,
        default_terminal_id: terminalId === null ? null : Number(terminalId),
        state: true,
        isCaja: isCaja,
        created_at: '',
        user_id: user_id
      };
      createWorkstation(create_workstation)
        .then(response => {
          toast.success('Estación de trabajo creada con éxito!');
          setShowCreateModal(false);
          create_workstation.workstation_id = (response as any).data.workstation_id;
          create_workstation.terminal_name = (response as any).data.terminal_name;
          setCurrentData([create_workstation, ...currentData]);
          if (onWorkstationCreated) {
            onWorkstationCreated(create_workstation);
          }
        })
        .catch(error => {
          console.error('Error al crear un workstation:', error);
          toast.error('Error al crear una estación de trabajo');
        });
  };

    return (
        <Modal className='modal-create-workstation' show={showCreateModal} onHide={() => setShowCreateModal(false)}>
          <Form onSubmit={handleFormSubmit}>
            <Modal.Header>
              <div className='form-modal-title-container'>
                <Modal.Title className='form-modal-title'>Crear estación de trabajo</Modal.Title>
              </div>
              <button type="button" className="modal-close-button" onClick={() => setShowCreateModal(false)}>
                <X size={22} />
              </button>
            </Modal.Header>
            <Modal.Body>
              <div className="px-2 py-1 flex flex-col gap-0">
                <div className="mp-form-group">
                  <label className="mp-form-label">Nombre</label>
                  <input
                    className="mp-form-input"
                    type="text"
                    name="workstation_name"
                    placeholder="Ej: Caja Principal"
                    required
                  />
                </div>

                <div className="mp-form-group">
                  <label className="mp-form-label">Descripción</label>
                  <textarea
                    className="mp-form-input mp-form-textarea"
                    name="workstation_description"
                    placeholder="Describa brevemente esta estación..."
                    rows={3}
                    required
                  />
                </div>

                <div className="mp-form-group">
                  <div className="mp-form-hint">
                    <label className="mp-form-label">Terminal por defecto</label>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="terminal-tooltip">Lugar donde se imprimirá la orden generada.</Tooltip>}
                    >
                      <span className="mp-form-hint-icon"><HiOutlineInformationCircle size={16} /></span>
                    </OverlayTrigger>
                  </div>
                  <input type="hidden" name="default_terminal_id" value={terminalId ?? ''} />
                  <SearchDropdown
                    items={terminals}
                    selected={terminals.find((t) => String(t.id) === String(terminalId)) || null}
                    setSelected={(selected: TerminalOption) => setTerminalId(Number(selected.id))}
                    displayProperty="name"
                    idProperty="id"
                    placeholder="Selecciona un terminal"
                  />
                </div>

                <div className="mp-form-group">
                  <label className="mp-form-checkbox">
                    <input
                      type="checkbox"
                      name="isCaja"
                      checked={isCaja}
                      onChange={handleCajaChange}
                    />
                    <span>Marcar como caja</span>
                  </label>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div className="mp-modal-footer">
                <button type="button" className="mp-modal-btn-cancel" onClick={() => setShowCreateModal(false)}>Cancelar</button>
                <button type="submit" className="mp-modal-btn-submit">Crear</button>
              </div>
            </Modal.Footer>
          </Form>
        </Modal>
      );
  };

  export default CreateWorkstation;
